// extracted by mini-css-extract-plugin
export default {"heading":"Footer_heading__dNqVb"};